// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/device_tracker.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/device_tracker.proto.
 */
export const file_api_gateway_v1_device_tracker: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_gateway_v1_core, file_google_protobuf_timestamp]);

/**
 * DeviceTracker represents a record of a device's movement.
 *
 * @generated from message gateway.v1.DeviceTracker
 */
export type DeviceTracker = Message<"gateway.v1.DeviceTracker"> & {
  /**
   * uuid is the unique identifier for the device movement  entry, generated as a UUID string.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * device_uuid is the unique identifier of the device associated with this movement  entry.
   *
   * @generated from field: string device_uuid = 2;
   */
  deviceUuid: string;

  /**
   * movement_type indicates the movement type of the device at the time of this  entry (e.g., warehouse, installation, etc.).
   *
   * @generated from field: gateway.v1.DeviceTrackerType movement_type = 3;
   */
  movementType: DeviceTrackerType;

  /**
   * installation_uuid is an optional field that is only set if the movement is "installation".
   *
   * @generated from field: string installation_uuid = 4;
   */
  installationUuid: string;

  /**
   * timestamp is the time when this movement  entry was recorded.
   *
   * @generated from field: google.protobuf.Timestamp in_timestamp = 5;
   */
  inTimestamp?: Timestamp | undefined;

  /**
   * out_timestamp is the time when the device left this location, which is set when the device moves to a different location or is removed from service. It is null if the device is currently at this location.
   *
   * @generated from field: google.protobuf.Timestamp out_timestamp = 6;
   */
  outTimestamp?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.DeviceTracker.
 * Use `create(DeviceTrackerSchema)` to create a new message.
 */
export const DeviceTrackerSchema: GenMessage<DeviceTracker> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 0);

/**
 * NewDeviceTrackerRequest is the request message for creating a new movement entry for a device based on its UUID.
 *
 * @generated from message gateway.v1.NewDeviceTrackerRequest
 */
export type NewDeviceTrackerRequest = Message<"gateway.v1.NewDeviceTrackerRequest"> & {
  /**
   * device_uuid is the unique identifier of the device for which to create a new movement entry.
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * movement_type indicates the movement type of the device (e.g., warehouse, installation, etc.) for the new movement entry.
   *
   * @generated from field: gateway.v1.DeviceTrackerType movement_type = 2;
   */
  movementType: DeviceTrackerType;

  /**
   * installation_uuid is an optional field that is only set if the movement is "installation".
   *
   * @generated from field: string installation_uuid = 3;
   */
  installationUuid: string;
};

/**
 * Describes the message gateway.v1.NewDeviceTrackerRequest.
 * Use `create(NewDeviceTrackerRequestSchema)` to create a new message.
 */
export const NewDeviceTrackerRequestSchema: GenMessage<NewDeviceTrackerRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 1);

/**
 * NewDeviceTrackerResponse is the response message for the NewDeviceTracker, containing the details of the newly created movement  entry for the device.
 *
 * @generated from message gateway.v1.NewDeviceTrackerResponse
 */
export type NewDeviceTrackerResponse = Message<"gateway.v1.NewDeviceTrackerResponse"> & {
  /**
   * device_movement_ is the newly created movement  entry for the device.
   *
   * @generated from field: gateway.v1.DeviceTracker device_tracker = 1;
   */
  deviceTracker?: DeviceTracker | undefined;
};

/**
 * Describes the message gateway.v1.NewDeviceTrackerResponse.
 * Use `create(NewDeviceTrackerResponseSchema)` to create a new message.
 */
export const NewDeviceTrackerResponseSchema: GenMessage<NewDeviceTrackerResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 2);

/**
 * GetDeviceTrackerRequest is the request message for retrieving the movement  of a device based on its UUID.
 *
 * @generated from message gateway.v1.GetDeviceTrackerRequest
 */
export type GetDeviceTrackerRequest = Message<"gateway.v1.GetDeviceTrackerRequest"> & {
  /**
   * device_uuid is the unique identifier of the device for which to retrieve the movement .
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;
};

/**
 * Describes the message gateway.v1.GetDeviceTrackerRequest.
 * Use `create(GetDeviceTrackerRequestSchema)` to create a new message.
 */
export const GetDeviceTrackerRequestSchema: GenMessage<GetDeviceTrackerRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 3);

/**
 * GetDeviceTrackerResponse is the response message for the GetDeviceTracker, containing the list of movement  entries for the specified device.
 *
 * @generated from message gateway.v1.GetDeviceTrackerResponse
 */
export type GetDeviceTrackerResponse = Message<"gateway.v1.GetDeviceTrackerResponse"> & {
  /**
   * movement_ is the list of movement  entries for the specified device, ordered by timestamp in descending order (most recent first).
   *
   * @generated from field: repeated gateway.v1.DeviceTracker device_tracker = 1;
   */
  deviceTracker: DeviceTracker[];
};

/**
 * Describes the message gateway.v1.GetDeviceTrackerResponse.
 * Use `create(GetDeviceTrackerResponseSchema)` to create a new message.
 */
export const GetDeviceTrackerResponseSchema: GenMessage<GetDeviceTrackerResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 4);

/**
 * GetDeviceTrackerByPageRequest is the request message for retrieving a paginated list of device movement  entries.
 *
 * @generated from message gateway.v1.GetDeviceTrackerByPageRequest
 */
export type GetDeviceTrackerByPageRequest = Message<"gateway.v1.GetDeviceTrackerByPageRequest"> & {
  /**
   * device_uuid is the unique identifier of the device for which to retrieve the movement .
   *
   * @generated from field: string device_uuid = 1;
   */
  deviceUuid: string;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of movement  entries.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceTrackerByPageRequest.
 * Use `create(GetDeviceTrackerByPageRequestSchema)` to create a new message.
 */
export const GetDeviceTrackerByPageRequestSchema: GenMessage<GetDeviceTrackerByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 5);

/**
 * GetDeviceTrackerByPageResponse is the response message for the GetDeviceTrackerByPage RPC.
 *
 * @generated from message gateway.v1.GetDeviceTrackerByPageResponse
 */
export type GetDeviceTrackerByPageResponse = Message<"gateway.v1.GetDeviceTrackerByPageResponse"> & {
  /**
   * movement_ is the list of movement  entries for the requested page.
   *
   * @generated from field: repeated gateway.v1.DeviceTracker device_tracker = 1;
   */
  deviceTracker: DeviceTracker[];

  /**
   * metadata contains pagination information.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceTrackerByPageResponse.
 * Use `create(GetDeviceTrackerByPageResponseSchema)` to create a new message.
 */
export const GetDeviceTrackerByPageResponseSchema: GenMessage<GetDeviceTrackerByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 6);

/**
 * UpdateDeviceTrackerRequest is the request message for updating an existing movement  entry for a device based on its UUID.
 *
 * @generated from message gateway.v1.UpdateDeviceTrackerRequest
 */
export type UpdateDeviceTrackerRequest = Message<"gateway.v1.UpdateDeviceTrackerRequest"> & {
  /**
   * device_tracker contains the updated details of the movement  entry to be updated for the device. The uuid field is required to identify which movement  entry to update, and the timestamp field will be updated by the system to reflect the time of the update.
   *
   * @generated from field: gateway.v1.DeviceTracker device_tracker = 1;
   */
  deviceTracker?: DeviceTracker | undefined;
};

/**
 * Describes the message gateway.v1.UpdateDeviceTrackerRequest.
 * Use `create(UpdateDeviceTrackerRequestSchema)` to create a new message.
 */
export const UpdateDeviceTrackerRequestSchema: GenMessage<UpdateDeviceTrackerRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 7);

/**
 * UpdateDeviceTrackerResponse is the response message for the UpdateDeviceTracker RPC, containing the details of the updated movement  entry.
 *
 * @generated from message gateway.v1.UpdateDeviceTrackerResponse
 */
export type UpdateDeviceTrackerResponse = Message<"gateway.v1.UpdateDeviceTrackerResponse"> & {
  /**
   * device_tracker is the updated movement  entry for the device.
   *
   * @generated from field: gateway.v1.DeviceTracker device_tracker = 1;
   */
  deviceTracker?: DeviceTracker | undefined;
};

/**
 * Describes the message gateway.v1.UpdateDeviceTrackerResponse.
 * Use `create(UpdateDeviceTrackerResponseSchema)` to create a new message.
 */
export const UpdateDeviceTrackerResponseSchema: GenMessage<UpdateDeviceTrackerResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 8);

/**
 * DeleteDeviceTrackerRequest is the request message for removing a movement  entry for a device based on its UUID.
 *
 * @generated from message gateway.v1.DeleteDeviceTrackerRequest
 */
export type DeleteDeviceTrackerRequest = Message<"gateway.v1.DeleteDeviceTrackerRequest"> & {
  /**
   * uuid is the unique identifier of the movement  entry to be deleted.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteDeviceTrackerRequest.
 * Use `create(DeleteDeviceTrackerRequestSchema)` to create a new message.
 */
export const DeleteDeviceTrackerRequestSchema: GenMessage<DeleteDeviceTrackerRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 9);

/**
 * DeleteDeviceTrackerResponse is the response message for the DeleteDeviceTracker RPC.
 *
 * @generated from message gateway.v1.DeleteDeviceTrackerResponse
 */
export type DeleteDeviceTrackerResponse = Message<"gateway.v1.DeleteDeviceTrackerResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteDeviceTrackerResponse.
 * Use `create(DeleteDeviceTrackerResponseSchema)` to create a new message.
 */
export const DeleteDeviceTrackerResponseSchema: GenMessage<DeleteDeviceTrackerResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_device_tracker, 10);

/**
 * DeviceTrackerType defines the type of movement for a device, such as warehouse, installation, or out of service.
 *
 * @generated from enum gateway.v1.DeviceTrackerType
 */
export enum DeviceTrackerType {
  /**
   * Unspecified device movement, used as a default value.
   *
   * @generated from enum value: DEVICE_TRACKER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Warehouse movement, indicating that the device is located in a warehouse.
   *
   * @generated from enum value: DEVICE_TRACKER_TYPE_WAREHOUSE = 1;
   */
  WAREHOUSE = 1,

  /**
   * Installation movement, indicating that the device is installed at a customer site.
   *
   * @generated from enum value: DEVICE_TRACKER_TYPE_INSTALLATION = 2;
   */
  INSTALLATION = 2,

  /**
   * Out of service movement, indicating that the device is currently not in service (e.g., being repaired, decommissioned, etc.).
   *
   * @generated from enum value: DEVICE_TRACKER_TYPE_OUT_OF_SERVICE = 3;
   */
  OUT_OF_SERVICE = 3,
}

/**
 * Describes the enum gateway.v1.DeviceTrackerType.
 */
export const DeviceTrackerTypeSchema: GenEnum<DeviceTrackerType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_device_tracker, 0);

/**
 * DeviceTrackerService defines the gRPC service for managing device movement and its .
 *
 * @generated from service gateway.v1.DeviceTrackerService
 */
export const DeviceTrackerService: GenService<{
  /**
   * NewDeviceTracker creates a new movement entry for a device based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceTrackerService.NewDeviceTracker
   */
  newDeviceTracker: {
    methodKind: "unary";
    input: typeof NewDeviceTrackerRequestSchema;
    output: typeof NewDeviceTrackerResponseSchema;
  },
  /**
   * GetDeviceTracker retrieves all the movement  of a device based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceTrackerService.GetDeviceTracker
   */
  getDeviceTracker: {
    methodKind: "unary";
    input: typeof GetDeviceTrackerRequestSchema;
    output: typeof GetDeviceTrackerResponseSchema;
  },
  /**
   * GetDeviceTrackerByPage retrieves a paginated list of movement  entries for a device based on its UUID and pagination parameters.
   *
   * @generated from rpc gateway.v1.DeviceTrackerService.GetDeviceTrackerByPage
   */
  getDeviceTrackerByPage: {
    methodKind: "unary";
    input: typeof GetDeviceTrackerByPageRequestSchema;
    output: typeof GetDeviceTrackerByPageResponseSchema;
  },
  /**
   * UpdateDeviceTracker updates an existing movement  entry for a device based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceTrackerService.UpdateDeviceTracker
   */
  updateDeviceTracker: {
    methodKind: "unary";
    input: typeof UpdateDeviceTrackerRequestSchema;
    output: typeof UpdateDeviceTrackerResponseSchema;
  },
  /**
   * DeleteDeviceTracker removes a movement  entry for a device based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceTrackerService.DeleteDeviceTracker
   */
  deleteDeviceTracker: {
    methodKind: "unary";
    input: typeof DeleteDeviceTrackerRequestSchema;
    output: typeof DeleteDeviceTrackerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_device_tracker, 0);

